import groceries from "../images/catagories/grocery.PNG";
import mobiles from "../images/catagories/mobiles.PNG";
import fashion from "../images/catagories/fashion.PNG";
import electronics from "../images/catagories/electronics.PNG";
import home from "../images/catagories/home.PNG";
import appliances from "../images/catagories/appliances.PNG";
import beauty from "../images/catagories/beauty.PNG";
import sports from "../images/catagories/sports.PNG";
import books from "../images/catagories/books.PNG";

export const catagories = [
  {
    id: 1,
    name: "Grocery",
    image: groceries,
  },
  {
    id: 2,
    name: "Mobiles",
    image: mobiles,
  },
  {
    id: 3,
    name: "Fashion",
    image: fashion,
  },
  {
    id: 4,
    name: "Electronics",
    image: electronics,
  },
  {
    id: 5,
    name: "Home",
    image: home,
  },
  {
    id: 6,
    name: "Appliances",
    image: appliances,
  },
  {
    id: 7,
    name: "Beauty",
    image: beauty,
  },
  {
    id: 8,
    name: "Sports",
    image: sports,
  },
  {
    id: 9,
    name: "More",
    image: books,
  },
];
